import { forwardRef } from 'react';

export const CaretDownIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} version="1.1" viewBox="0 0 29 14" {...props}>
        <polygon fill="currentColor" points="0.15,0 14.5,14.35 28.85,0 " />
      </svg>
    );
  },
);
